import React from 'react'

const BottomComboButtons = ({ onClick1, name1, onClick2, name2, extraClasses, extra1, extra2 }) => {
    return (
        <div className={`mt-10 text-lg-right text-center ${extraClasses}`}>
            <button
                type="button"
                className={`all_bottom_buttons ml-auto ${extra1}`}
                onClick={onClick1}
            >
                {name1}
            </button>

            <button
                type="button"
                className={`all_bottom_buttons ml-auto ${extra2}`}
                onClick={onClick2}
            >
                {name2}
            </button>
        </div>
    )
}

export default BottomComboButtons